module.exports = __webpack_public_path__ + "0999e5071bc0348f64a88fb78f0b1534.png";